import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import {
  createOrder,
  fetchOpenOrders,
  fetchBalance,
} from '../../actions';

const qs = require('query-string');

class Exchange extends Component {
  constructor(props) {
    super(props);
    const filterParams = qs.parse(this.props.location.search);
    this.state = {
      filterParams,
      currentTab: 'buy',
      confirmBuy: '',
      confirmSell: '',
      buyAmount: '0.00000000',
      buyPrice: '0.00000000',
      buySpend: '0.00000000',
      sellAmount: '0.00000000',
      sellPrice: '0.00000000',
      sellReceive: '0.00000000',
      currentPrice: '',
      prevPair: this.props.pair || '',
      pristine: true,
      maxBalanceA: '0.00000000',
      maxBalanceB: '0.00000000',
    };
    this.changeTab = this.changeTab.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.clearForm = this.clearForm.bind(this);
    this.submitOrder = this.submitOrder.bind(this);
    this.getMaxBalances = this.getMaxBalances.bind(this);
    this.maxSpend = this.maxSpend.bind(this);
    this.maxSell = this.maxSell.bind(this);
  }

  componentDidMount() {
    const { currentPrice, filterParams } = this.state;
    const { latestPrice } = this.props;

    if (currentPrice !== latestPrice) {
      this.setState({ buyPrice: latestPrice, sellPrice: latestPrice, currentPrice: latestPrice });
    }
    if (filterParams.ex === 'buy') {
      this.setState({ currentTab: 'buy' });
    }
    if (filterParams.ex === 'sell') {
      this.setState({ currentTab: 'sell' });
    }
    // const numInputs = document.querySelectorAll('input[type="number"]');
    // numInputs.forEach(function(elem) {
    //   elem.addEventListener('keypress', function (e) {
    //     if (e.keyCode === 8 || e.key === '.') { return }
    //     if (e.keyCode < 48 || e.keyCode > 57)
    //     { e.preventDefault(); }
    //   });
    // });
    this.getMaxBalances();
  }

  // componentWillUnmount() {
  //   const numInputs = document.querySelectorAll('input[type="number"]');
  //   numInputs.forEach(function(elem) {
  //     elem.removeEventListener('keypress', function (e) {
  //       if (e.keyCode === 8 || e.key === '.') { return }
  //       if (e.keyCode < 48 || e.keyCode > 57)
  //       { e.preventDefault(); }
  //     });
  //   });
  // }

  componentDidUpdate() {
    const { currentPrice, prevPair } = this.state;
    const { latestPrice, pair } = this.props;

    if (currentPrice !== latestPrice) {
      this.setState({ buyPrice: latestPrice, sellPrice: latestPrice, currentPrice: latestPrice })
    }
    if (prevPair !== pair) {
      this.getMaxBalances();
      this.setState({
        buyAmount: '0.00000000',
        buyPrice: latestPrice,
        buySpend: '0.00000000',
        sellAmount: '0.00000000',
        sellPrice: latestPrice,
        sellReceive: '0.00000000',
        confirmBuy: '',
        confirmSell: '',
        prevPair: pair,
      });
    }
  }

  handleChange(event) {
    const { buyAmount, buyPrice, buySpend, sellAmount, sellPrice, sellReceive } = this.state;
    let value;
    let decLength;
    if (event.target.value) {
      value = event.target.value;
      if (value.indexOf('.') !== -1) {
        decLength = value.split('.')[1].length;
        if (decLength > 8) {
          value = Number(event.target.value).toFixed(8);
        }
      }
    }

    // Buy
    if (event.target.id === 'buyAmount') {
      if (buyPrice) {
        this.setState({ buyAmount: value, buySpend: (event.target.value * buyPrice).toFixed(8), pristine: false });
        return;
      }
      if (buySpend) {
        this.setState({ buyAmount: value, buyPrice: (buySpend / event.target.value).toFixed(8), pristine: false });
        return;
      }
    }
    if (event.target.id === 'buyPrice') {
      if (buyAmount) {
        this.setState({ buyPrice: value, buySpend: (buyAmount * event.target.value).toFixed(8), pristine: false });
        return;
      }
      if (buySpend) {
        this.setState({ buyPrice: value, buyAmount: (buySpend / event.target.value).toFixed(8), pristine: false });
        return;
      }
    }
    if (event.target.id === 'buySpend') {
      if (buyPrice) {
        this.setState({ buySpend: value, buyAmount: (event.target.value / buyPrice).toFixed(8), pristine: false });
        return;
      }
    }

    // Sell
    if (event.target.id === 'sellAmount') {
      if (sellPrice) {
        this.setState({ sellAmount: value, sellReceive: (event.target.value * sellPrice).toFixed(8), pristine: false });
        return;
      }
      if (sellReceive) {
        this.setState({ sellAmount: value, sellPrice: (sellReceive / event.target.value).toFixed(8), pristine: false });
        return;
      }
    }
    if (event.target.id === 'sellPrice') {
      if (sellAmount) {
        this.setState({ sellPrice: value, sellReceive: (sellAmount * event.target.value).toFixed(8), pristine: false });
        return;
      }
      if (sellReceive) {
        this.setState({ sellPrice: value, sellAmount: (sellReceive / event.target.value).toFixed(8), pristine: false });
        return;
      }
    }
    if (event.target.id === 'sellReceive') {
      if (sellAmount) {
        this.setState({ sellReceive: value, sellPrice: (event.target.value / sellAmount).toFixed(8), pristine: false });
        return;
      }
      if (sellPrice) {
        this.setState({ sellReceive: value, sellAmount: (event.target.value / sellPrice).toFixed(8), pristine: false });
        return;
      }
    }
    // this.setState({ [event.target.id]: event.target.value });
  }

  clearForm() {
    const { latestPrice } = this.props;
    this.setState({
      buyAmount: '0.00000000',
      buyPrice: latestPrice,
      buySpend: '0.00000000',
      sellAmount: '0.00000000',
      sellPrice: latestPrice,
      sellReceive: '0.00000000',
      confirmBuy: '',
      confirmSell: '',
      pristine: true,
    });
  }

  getMaxBalances() {
    const { exchA, exchB, balance } = this.props;

    let exchAData;
    let exchAAvailable;
    let exchBData;
    let exchBAvailable;
    let maxBalanceA;
    let maxBalanceB;

    if (balance && balance.data && balance.data.length) {
      exchAData = balance.data.filter((item) => item.handle === exchA.toUpperCase());
      exchBData = balance.data.filter((item) => item.handle === exchB.toUpperCase());
    }
    if (exchAData && exchAData.length) {
      exchAAvailable = exchAData.filter((item) => item.type === 'AVAILABLE');
    }
    if (exchBData && exchBData.length) {
      exchBAvailable = exchBData.filter((item) => item.type === 'AVAILABLE');
    }
    if (exchAAvailable && exchAAvailable[0] && exchAAvailable[0].quantity) {
      maxBalanceA = exchAAvailable[0].quantity;
    }
    if (exchBAvailable && exchBAvailable[0] && exchBAvailable[0].quantity) {
      maxBalanceB = exchBAvailable[0].quantity;
    }

    if (maxBalanceA && maxBalanceB) {
      this.setState({ maxBalanceA, maxBalanceB });
    }
  }

  submitOrder(type) {
    const { buyAmount, buyPrice, buySpend, sellAmount, sellPrice, maxBalanceA, maxBalanceB } = this.state;
    const { dispatch, pair } = this.props;
    let data;

    if (type === 'SELL') {
      data = {
        pair,
        type,
        matchType: 'LIMIT',
        quantity: sellAmount,
        price: sellPrice,
      };
      if (sellAmount === maxBalanceA) {
        const maxTrue = { max: true };
        data = { ...data, ...maxTrue };
      }
    }
    if (type === 'BUY') {
      data = {
        pair,
        type,
        matchType: 'LIMIT',
        quantity: buyAmount,
        price: buyPrice,
      };
      if (buySpend === maxBalanceB) {
        const maxTrue = { max: true };
        data = { ...data, ...maxTrue };
      }
    }

    dispatch(createOrder(data))
      .then((res) => {
        // if (res.type === 'CREATE_ORDERS_FAIL') {
        // }
        if (res.type === 'CREATE_ORDERS_SUCCESS') {
          const openData = {
            pair,
            status: 'OPEN',
            queued: true,
            pristine: true,
            self: true,
          };
          this.clearForm();
          dispatch(fetchBalance({}));
          dispatch(fetchOpenOrders(openData));
        }
      });
  }

  maxSpend() {
    const { maxBalanceB } = this.state;

    const spendChange = {
      target: {
        id: 'buySpend',
        value: maxBalanceB,
      },
    };

    this.handleChange(spendChange);
  }

  maxSell() {
    const { maxBalanceA } = this.state;

    const sellChange = {
      target: {
        id: 'sellAmount',
        value: maxBalanceA,
      },
    };

    this.handleChange(sellChange);
  }

  changeTab(tab) {
    const { currentTab } = this.state;
    const filterParams = qs.parse(this.props.location.search);
    if (currentTab !== tab) {
      const field = 'ex';
      filterParams[field] = tab;
      this.props.history.push({ search: '?' + qs.stringify(filterParams) });
      this.setState({
        filterParams,
        currentTab: tab,
        confirmBuy: '',
        confirmSell: '',
      });
    }
  }

  render() {
    const { user, exchA, exchB, isOfType } = this.props;
    const { currentTab, confirmBuy, confirmSell, buyAmount, buyPrice, buySpend, sellAmount, sellPrice, sellReceive, pristine } = this.state;

    const tradesDisabled = ((user && user.me && user.me.flags && user.me.flags.tradesDisabled) && (user.me.flags.tradesDisabled === true)) && ((user && user.me && user.me.flags && user.me.flags.verified) && (user.me.flags.verified === true));

    const buyCompleted = buyAmount && buyPrice && (buySpend > 0) && !pristine;
    const sellCompleted = sellAmount && sellPrice && (sellReceive > 0) && !pristine;

    let useA;
    let useB;
    if (exchA) {
      useA = exchA;
    }
    if (exchB) {
      useB = exchB;
    }
    if (useA === 'silv') {
      useA = 'silver';
    }
    if (useB === 'silv') {
      useB = 'silver';
    }

    // TODO
    if (tradesDisabled) {
      return (
        <div className="cell tab-panel">
          <div className="tp-tabs">
            <div
              className={currentTab === 'buy' ? 'tpt-t active' : 'tpt-t'}
              onClick={() => this.changeTab('buy')}
            >
              Buy {useA}
            </div>
            <div
              className={currentTab === 'sell' ? 'tpt-t active' : 'tpt-t'}
              onClick={() => this.changeTab('sell')}
            >
              Sell {useA}
            </div>
          </div>
          {currentTab === 'buy' && (
            <div className="cell panel">
              <div className="order-title buy">Limit</div>
              <div>
                <p style={{ textAlign: 'center', fontWeight: 'bold' }}>Trading Temporarily Disabled</p>
                <p style={{ textAlign: 'center' }}>Due to increased KYC/due diligence requirements, trading has been temporarily disabled. Please contact support for more info, or check back later.</p>
              </div>
            </div>
          )}
          {currentTab === 'sell' && (
            <div className="cell panel">
              <div className="order-title sell">Limit</div>
              <div>
                <p style={{ textAlign: 'center', fontWeight: 'bold' }}>Trading Temporarily Disabled</p>
                <p style={{ textAlign: 'center' }}>Due to increased KYC/due diligence requirements, trading has been temporarily disabled. Please contact support for more info, or check back later.</p>
              </div>
            </div>
          )}
        </div>
      );
    }

    return (
      <div className="cell tab-panel">
        <div className="tp-tabs">
          <div
            className={currentTab === 'buy' ? 'tpt-t active' : 'tpt-t'}
            onClick={() => this.changeTab('buy')}
          >
            Buy {useA}
          </div>
          <div
            className={currentTab === 'sell' ? 'tpt-t active' : 'tpt-t'}
            onClick={() => this.changeTab('sell')}
          >
            Sell {useA}
          </div>
        </div>

        {currentTab === 'buy' && (
          <div className="cell panel">
            <div className="order-title buy">Limit</div>
            { confirmBuy ? (
              <div>
                <div>
                  { isOfType(useA, 'METAL') ? (
                    'Amount to buy in grams'
                  ) : (
                    'Amount to buy'
                  )}
                  <div className="trade">
                    {buyAmount}
                    <span>
                      {useA}
                    </span>
                  </div>
                </div>
                <div>
                  { isOfType(useA, 'METAL') ? (
                    <span>
                      Price per gram in
                      <span style={{ textTransform: 'uppercase' }}> {useB}</span>
                    </span>
                  ) : (
                    <span>
                      Price per
                      <span style={{ textTransform: 'uppercase' }}> {useA} </span>
                      in
                      <span style={{ textTransform: 'uppercase' }}> {useB}</span>
                    </span>
                  )}
                  <div className="trade">
                    {buyPrice}
                    <span> {useB}</span>
                  </div>
                </div>
                <div>
                  Total to spend
                  <div className="trade">
                    {buySpend}
                    <span> {useB}</span>
                  </div>
                </div>
                <div className="button-area">
                  <button className="vlt-button" type="submit" onClick={() => this.submitOrder('BUY')}>
                    <span>
                      Confirm Order
                    </span>
                  </button>
                  <button type="button" className="vlt-button dark-b" onClick={() => this.setState({ confirmBuy: !confirmBuy })}>
                    <span>
                      Cancel
                    </span>
                  </button>
                </div>
              </div>
            ) : (
              <div>
                <div>
                  { isOfType(useA, 'METAL') ? (
                    'Amount to buy in grams'
                  ) : (
                    'Amount to buy'
                  )}
                  <div className="input-wrapper trade">
                    <input className="input" type="number" name="baseAmount" placeholder="0" value={buyAmount} id="buyAmount" onChange={this.handleChange} min="0" step="0.000001" />
                    <span>{useA}</span>
                  </div>
                </div>
                <div>
                  { isOfType(useA, 'METAL') ? (
                    <span>
                      Price per gram in
                      <span style={{ textTransform: 'uppercase' }}> {useB}</span>
                    </span>
                  ) : (
                    <span>
                      Price per
                      <span style={{ textTransform: 'uppercase' }}> {useA} </span>
                      in
                      <span style={{ textTransform: 'uppercase' }}> {useB}</span>
                    </span>
                  )}
                  <div className="input-wrapper trade">
                    <input className="input" type="number" name="price" placeholder="0" onChange={this.handleChange} value={buyPrice} id="buyPrice" min="0" step="0.000001" />
                    <span>{useB}</span>
                  </div>
                </div>
                <div>
                  Total to spend
                  <div className="input-btn-trade">
                    <div className="input-wrapper trade">
                      <input className="input" type="number" name="spend" placeholder="0" onChange={this.handleChange} value={buySpend} id="buySpend" min="0" step="0.000001" />
                      <span>{useB}</span>
                    </div>
                    <button className="vlt-button" onClick={this.maxSpend}>
                      <span>
                        Max
                      </span>
                    </button>
                  </div>
                </div>
                <div className="button-area">
                  <button type="button" className="vlt-button dark-b" onClick={this.clearForm}>
                    <span>
                      Reset
                    </span>
                  </button>
                  <button type="button" className="vlt-button" disabled={!buyCompleted} onClick={() => this.setState({ confirmBuy: !confirmBuy })}>
                    <span>
                      Place Order
                    </span>
                  </button>
                </div>
              </div>
            )}
          </div>
        )}

        {currentTab === 'sell' && (
          <div className="cell panel">
            <div className="order-title sell">Limit</div>
            { confirmSell ? (
              <div>
                <div>
                  { useA === 'gold' || useA === 'silver' ? (
                    'Amount to sell in grams'
                  ) : (
                    'Amount to sell'
                  )}
                  <div className="trade">
                    {sellAmount}
                    <span>{useA}</span>
                  </div>
                </div>
                <div>
                  { isOfType(useA, 'METAL') ? (
                    <span>
                      Price per gram in
                      <span style={{ textTransform: 'uppercase' }}> {useB}</span>
                    </span>
                  ) : (
                    <span>
                      Price per
                      <span style={{ textTransform: 'uppercase' }}> {useA} </span>
                      in
                      <span style={{ textTransform: 'uppercase' }}> {useB}</span>
                    </span>
                  )}
                  <div className="trade">
                    {sellPrice}
                    <span>{useB}</span>
                  </div>
                </div>
                <div>
                  Total to receive
                  <div className="trade">
                    {sellReceive}
                    <span>{useB}</span>
                  </div>
                </div>
                <div className="button-area">
                  <button className="vlt-button" type="submit" onClick={() => this.submitOrder('SELL')}>
                    <span>
                      Confirm Order
                    </span>
                  </button>
                  <button type="button" className="vlt-button dark-b" onClick={() => this.setState({ confirmSell: !confirmSell })}>
                    <span>
                      Back
                    </span>
                  </button>
                </div>
              </div>
            ) : (
              <div>
                <div>
                  { isOfType(useA, 'METAL') ? (
                    'Amount to sell in grams'
                  ) : (
                    'Amount to sell'
                  )}
                  <div className="input-btn-trade">
                    <div className="input-wrapper trade">
                      <input className="input" type="number" name="baseAmount" placeholder="0" value={sellAmount} onChange={this.handleChange} id="sellAmount" min="0" step="0.000001" />
                      <span>{useA}</span>
                    </div>
                    <button className="vlt-button" onClick={this.maxSell}>
                      <span>
                        Max
                      </span>
                    </button>
                  </div>
                </div>
                <div>
                  { isOfType(useA, 'METAL') ? (
                    <span>
                      Price per gram in
                      <span style={{ textTransform: 'uppercase' }}> {useB}</span>
                    </span>
                  ) : (
                    <span>
                      Price per
                      <span style={{ textTransform: 'uppercase' }}> {useA} </span>
                      in
                      <span style={{ textTransform: 'uppercase' }}> {useB}</span>
                    </span>
                  )}
                  <div className="input-wrapper trade">
                    <input className="input" type="number" name="price" placeholder="0" value={sellPrice} onChange={this.handleChange} id="sellPrice" min="0" step="0.000001" />
                    <span>{useB}</span>
                  </div>
                </div>
                <div>
                  Total to receive
                  <div className="input-wrapper trade">
                    <input className="input" type="number" name="spend" placeholder="0" value={sellReceive} onChange={this.handleChange} id="sellReceive" min="0" step="0.000001" />
                    <span>{useB}</span>
                  </div>
                </div>
                <div className="button-area">
                  <button type="button" className="vlt-button dark-b" onClick={this.clearForm}>
                    <span>
                      Reset
                    </span>
                  </button>
                  <button type="button" className="vlt-button" disabled={!sellCompleted} onClick={() => this.setState({ confirmSell: !confirmSell })}>
                    <span>
                      Place Order
                    </span>
                  </button>
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.user,
  orders: state.order,
  balance: state.balance.balance,
});

export default withRouter(connect(mapStateToProps)(Exchange));
